var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 184,
    viewBox: "0 0 117 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1559_7001",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 117,
    height: 184
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H92C105.807 0 117 11.1929 117 25V184H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1559_7001)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1559_7001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.87 34.22C139.241 27.6305 130.429 24 121.054 24C111.678 24 102.877 27.6305 96.2476 34.22L91.432 39.0139L86.6263 34.2298C79.9957 27.6305 71.1846 24 61.8089 24C52.4332 24 43.6319 27.6305 37.0028 34.2312C23.3337 47.8486 23.3337 70.0041 37.0028 83.6214L88.3369 134.724C89.1879 135.571 90.3142 136 91.432 136C91.5407 136 91.6479 135.994 91.7566 135.987C92.9817 136.079 94.2378 135.657 95.1763 134.723L137.96 91.4965C138.032 91.4346 138.093 91.3644 138.155 91.2927L145.871 83.6228C159.55 70.0055 159.55 47.8401 145.871 34.2228L145.87 34.22Z",
    fill: "#726FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.054 22C130.647 22 139.692 25.6026 146.616 32.1582L147.279 32.8018L147.511 33.0312L147.519 33.0469C161.744 47.4651 161.666 70.7205 147.282 85.04L147.281 85.041L139.609 92.667C139.555 92.729 139.47 92.8196 139.368 92.916L96.5977 136.13L96.5869 136.141C95.2556 137.466 93.4832 138.079 91.748 137.988C91.6535 137.993 91.5459 138 91.4316 138C89.808 138 88.1675 137.378 86.9258 136.142L35.5918 85.0391L35.5908 85.0381C21.1375 70.6392 21.1375 47.2133 35.5908 32.8145H35.5918C42.5966 25.8397 51.9053 22.0001 61.8086 22C71.4021 22 80.448 25.6026 87.374 32.168L88.0371 32.8125L91.4316 36.1914L94.8369 32.8027L94.8379 32.8018C101.842 25.8393 111.15 22 121.054 22Z",
    fill: "#726FB3",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.259 52.6811C120.279 48.7486 114.989 46.582 109.36 46.582C103.731 46.582 98.447 48.7486 94.4669 52.6811L91.5757 55.5419L88.6905 52.6869C84.7095 48.7486 79.4195 46.582 73.7904 46.582C68.1614 46.582 62.8773 48.7486 58.8972 52.6878C50.6905 60.8142 50.6905 74.0361 58.8972 82.1625L89.7175 112.659C90.2284 113.165 90.9046 113.421 91.5757 113.421C91.641 113.421 91.7054 113.417 91.7706 113.413C92.5061 113.468 93.2603 113.216 93.8238 112.659L119.511 86.8622C119.554 86.8253 119.59 86.7834 119.628 86.7406L124.26 82.1634C132.473 74.0369 132.473 60.8092 124.26 52.6827L124.259 52.6811Z",
    fill: "#8780CF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1559_7001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5693 96.2103C56.9776 93.6342 53.5329 92.2148 49.8675 92.2148C46.2021 92.2148 42.7613 93.6342 40.1696 96.2103L38.2869 98.0845L36.4082 96.2142C33.816 93.6342 30.3712 92.2148 26.7058 92.2148C23.0404 92.2148 19.5996 93.6342 17.0079 96.2147C11.664 101.538 11.664 110.2 17.0079 115.524L37.0769 135.502C37.4096 135.834 37.8499 136.001 38.2869 136.001C38.3294 136.001 38.3714 135.999 38.4139 135.996C38.8928 136.032 39.3839 135.867 39.7508 135.502L56.4772 118.602C56.5053 118.578 56.529 118.551 56.5533 118.523L59.5698 115.524C64.9176 110.201 64.9176 101.535 59.5698 96.2114L59.5693 96.2103Z",
    fill: "#726FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8672 90.2148C53.9286 90.2148 57.7647 91.7423 60.6982 94.5195L60.9795 94.792L61.2119 95.0234L61.2188 95.0371C67.1123 101.16 67.033 110.916 60.9805 116.941L60.9795 116.942L58.0029 119.901C57.9755 119.931 57.938 119.967 57.8965 120.008L57.8984 120.01L41.1719 136.909L41.1621 136.919C40.4012 137.676 39.3912 138.034 38.4004 137.996C38.3655 137.997 38.3274 138.001 38.2871 138.001C37.3442 138.001 36.3894 137.64 35.666 136.92L15.5967 116.941V116.94C9.46816 110.835 9.46816 100.903 15.5967 94.7979L15.8779 94.5244C18.8113 91.7428 22.644 90.2148 26.7061 90.2148C30.8985 90.2149 34.8512 91.8427 37.8193 94.7969L38.2861 95.2617L38.7588 94.793L38.7598 94.792C41.7266 91.8429 45.6744 90.2149 49.8672 90.2148Z",
    fill: "#8780CF",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.69 104.725C48.3016 103.343 46.4562 102.582 44.4926 102.582C42.529 102.582 40.6857 103.343 39.2973 104.725L38.2888 105.73L37.2823 104.727C35.8936 103.343 34.0482 102.582 32.0846 102.582C30.121 102.582 28.2777 103.343 26.8893 104.727C24.0265 107.583 24.0265 112.228 26.8893 115.083L37.6405 125.798C37.8188 125.976 38.0547 126.066 38.2888 126.066C38.3115 126.066 38.334 126.065 38.3568 126.063C38.6133 126.082 38.8764 125.994 39.073 125.798L48.0335 116.735C48.0486 116.722 48.0613 116.707 48.0743 116.692L49.6903 115.084C52.5552 112.228 52.5552 107.581 49.6903 104.726L49.69 104.725Z",
    fill: "#726FB3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1559_7001",
    x: 14.751,
    y: 14,
    width: 153.379,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1559_7001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1559_7001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1559_7001",
    x: 1,
    y: 82.2148,
    width: 74.5811,
    height: 67.7852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1559_7001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1559_7001",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartGroup);
export default __webpack_public_path__ + "static/media/heart-group.27100d78d2a4ca1afa0fd25725ca1aa1.svg";
export { ForwardRef as ReactComponent };